import { render, staticRenderFns } from "./HamburgerMenuButtonV2.vue?vue&type=template&id=f2d2920c"
import script from "./HamburgerMenuButtonV2.vue?vue&type=script&lang=js"
export * from "./HamburgerMenuButtonV2.vue?vue&type=script&lang=js"
import style0 from "./HamburgerMenuButtonV2.vue?vue&type=style&index=0&id=f2d2920c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports